<template>
  <div id="app" class="page-wrapper" v-cloak>
    <div class="main-header">
      <a href="#/" class="logo"><img src="https://fs.58keeper.com/keeper.png"></a>
      <div class="nav-menu" @click="toggleNav">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <transition name="bounce">
        <div class="nav" v-show="menuState">
          <div class="nav-menu-close" @click="toggleNav">
            <span></span>
            <span></span>
          </div>
          <a class="logo" href="#/"><img src="https://fs.58keeper.com/keeper.png"></a>
          <div class="mm-panels">
            <div class="mm-panel">
              <ul class="mm-listview row">
                <li class="col-md-li">
                  <span>关于</span>
                  <div class="sub-mm-panel">
                    <a href="#/" @click="hade">首页</a>
                    <a href="#/about" @click="hade">关于多妙</a>
                  </div>
                </li>
                <li class="col-md-li">
                  <span>产品和服务</span>
                  <div class="sub-mm-panel">
                    <a href="#/franchise" @click="hade">多妙平台</a>
                  </div>
                </li>
                <li class="col-md-li">
                  <span>多妙旅租</span>
                  <div class="sub-mm-panel">
                    <a href="#/discount" @click="hade">租房优惠</a>
                  </div>
                </li>
                <li class="col-md-li">
                  <span>联系多妙</span>
                  <div class="sub-mm-panel">
                    <a href="#/contact" @click="hade">联系托管</a>
                    <a href="#/joinus" @click="hade">加入我们</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="nav-search"></div>
        </div>
      </transition>
    </div>

    <router-view/>

    <div class="main-footer">
      <div class="com-container">
        <div class="row">
          <div class="col-md-5"><img class="foot-logo" src="https://fs.58keeper.com/keeper.png"></div>
          <div class="col-md-7 foot-nav">
            <a href="#/about">关于多妙</a>
            <a href="#/franchise">多妙平台</a>
            <a href="#/contact">联系托管</a>
            <a href="#/joinus">加入我们</a>
          </div>
        </div>
        <div class="Linkicon">
          <a href="javascript:;">
            <i class="tb-icon"></i>租房优惠
            <img src="./images/qrcode.jpg">
          </a>
          <a href="javascript:;">
            <i class="wechat-icon"></i>关注微信
            <img src="./images/qrcode.jpg">
          </a>
        </div>
        <p class="copy">
          COPYRIGHT (&copy;) 2019-2022<br>
          海南多妙公寓管理有限公司<br>
          <a href="https://beian.miit.gov.cn" target="_blank" class="bah">琼ICP备 18003969 号</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      menuState: false
    }
  },
  methods: {
    toggleNav () {
      this.menuState = !this.menuState
    },
    hade () {
      this.menuState = false
    }
  },
  computed: {},
  mounted () {}
}
</script>

<style>
  @import './styles/app.css';

  [v-cloak] {
   display: none;
  }

  .bounce-enter-active {
    animation: bounce-in .5s;
  }
  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }
  @keyframes bounce-in {
    0% {
      opacity: .8;
      transform: translateY(-90%);
    }
    100% {
      opacity: 1;
      transform: translateY(0%);
    }
  }
  .bah:hover{
    color: red !important;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue